import { Component, ElementRef, OnInit, Renderer2, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog'; // 👈 add this
import { SnackBarHandler } from 'src/app/other/open-snack-bar';
import { AUTHGWCONSTANTS } from '../authconstatnts';
import { OtpService } from './otp.service';
import { StaticMemory } from 'src/app/handler/static_memory';
import { SigninService } from '../signin/signin.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-otp',
    templateUrl: './otp.component.html',
    styleUrls: ['./otp.component.scss'],
    providers: [OtpService],
    standalone: false
})
export class OtpComponent implements OnInit {
  entityName = StaticMemory.businessProfileObject.name;
  data: any;
  loading = true;
  isLoading = false;
  imgSrc = '';
  otpDigits = '';
  otpValid: boolean = false;

  constructor(
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private service: OtpService,
    private snackBar: SnackBarHandler,
    private signinService: SigninService,
    @Optional() private dialogRef?: MatDialogRef<OtpComponent>,
  ) {
    this.data = {};
    this.data.phoneNumber = null;
    this.imgSrc = 'assets/images/background_jompoi.jpg';
    this.data.hashKey = localStorage.getItem(AUTHGWCONSTANTS.hash);
  }

  // are we inside a MatDialog?
  get isDialog(): boolean {
    return !!this.dialogRef;
  }

  ngOnInit(): void {
    const value = JSON.parse(sessionStorage.getItem('sign-object'));
    if (value) {
      this.data.phoneNumber = value.phoneNumber;
    }

    setTimeout(() => {
      this.loading = false;
    }, 300);
  }

  onLogin(): void {
    sessionStorage.removeItem('sign-object');
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.router.navigate(['auth/signin']);
    }
  }

  onChangeSignupDetails(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.signinService.otpState$.next('close');
    } else {
      window.history.back();
    }
  }

  onVerifyOtp(): void {
    if (this.isValid()) {
      this.isLoading = true;
      const body: any = {
        method: 0,
        dialCode: 91,
        applicationId: environment.applicationId,
        phoneNumber: Number(this.data.phoneNumber),
        otp: Number(this.otpDigits),
        hash: this.data.hashKey,
      };
      this.service.putSentOtp(body).subscribe(
        (success) => {
          if (success.status && success.result && success.result.length) {
            localStorage.setItem(AUTHGWCONSTANTS.xenAuth, success.result[0]);
            localStorage.removeItem(AUTHGWCONSTANTS.guestAuth);
            if (this.service.updateHeaders()) {
              this.router.navigate(['/']).then(() => {
                window.location.reload();
              });
            }
            sessionStorage.removeItem('sign-object');
            if (this.dialogRef) {
              this.dialogRef.close();
              this.signinService.otpState$.next('close');
            }
          } else {
            this.snackBar.openErrorSnackBar(success.message);
          }
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        },
        (error: any) => {
          this.snackBar.openErrorSnackBar('HTTP ERROR IN POST OTP');
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        },
      );
    }
  }

  isValid(): boolean {
    if (this.otpDigits.length !== 6) {
      this.snackBar.openErrorSnackBar('Invalid OTP digits. Please enter all digits.');
      return false;
    }
    return true;
  }

  isOtpValid(): void {
    const otp = this.otpDigits?.toString() ?? '';
    if (otp.length > 6) {
      this.otpDigits = otp.substring(0, 6);
    }
    this.otpValid = /^\d{6}$/.test(this.otpDigits);
  }
}
